import traqing from '@yola/traqing.js';

const identify = (userId, ...args) => {
  traqing.segment.identify(userId, ...args);
};

export default identify;
